module.exports = __webpack_public_path__ + "img/1558932192.b8eb7cd9.jpg";